module.exports = __webpack_public_path__ + "static/media/twitter.ce9ea27e.svg";